import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import { ToastContainer } from "react-toastify";
import { getGuestLogin } from "../../../auth";
import AdhocLoginScreens from "../../../container/LoginScreens/AdhocLoginScreens/AdhocLoginScreens";
import AdhocUploadDocuments from "../../../container/AdhocUploadDocuments/AdhocUploadDocuments";

function AdhocLayout() {
  const isGuestUserIsAuthenticated = getGuestLogin(); // You can replace this with your authentication logic

  return (
    <>
      <Router>
        <Switch>
          <Route path="/guest-login">
            {isGuestUserIsAuthenticated ? (
              <Redirect to="/guest-form-submission" />
            ) : (
              <AdhocLoginScreens />
            )}
          </Route>
          <Route path="/guest-form-submission">
            {isGuestUserIsAuthenticated ? (
              <AdhocUploadDocuments />
            ) : (
              <AdhocLoginScreens />
            )}
          </Route>
        </Switch>
      </Router>
      <ToastContainer />
    </>
  );
}

export default AdhocLayout;
